import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import classNames from 'classnames'
import moment from 'moment'
import { isTodayDay, isTomorrowDay } from 'helpers/datetime'
import isEmpty from 'lodash/isEmpty'

import {
    Tooltip,
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import { openExternalBrowserWithAuth } from 'helpers/web_to_client'
import { sendEnterGlobalMapSoundState, playEnterGlobalMapSound } from 'state/actions/sounds'

import FamePoints from 'components/FamePoints/FamePoints'

import {
    GLOBAL_MAP,
    GLOBAL_MAP_DISABLED,
    PERSONAL_FAME_POINTS,
    PERSONAL_FAME_POINTS_BALANCE,
    PERSONAL_FAME_POINTS_EARN,
    BATTLES_NOW,
    TOMMOROW_TIME,
    CUSTOM_DATE_TIME,
    TODAY_TIME,
    GLOBAL_MAP_NEAREST_BATTLE_TIME,
} from '../translations'

import {
    WGCWX_SHOP,
    WGCWX_SHOP_REWARDS,
    WGCWX_BATTLE_SCHEDULE,
    WGCWX_LEADERBOARDS,
} from 'urls'

import styles from './cards.scss'

export class GlobalMapCard extends React.Component {
    static propTypes = {
        craftMachineUrl: PropTypes.string,
        isSomeServiceEnabled: PropTypes.bool,
        isCraftServiceEnabled: PropTypes.bool,
        leaderboardsEnabled: PropTypes.bool,
        // eslint-disable-next-line react/no-unused-prop-types
        personalShopEnabled: PropTypes.bool,
        personalBonusesEnabled: PropTypes.bool,
        eventRewardsEnabled: PropTypes.bool,
        battleScheduleEnabled: PropTypes.bool,
        eventName: PropTypes.string,
        famePoints: PropTypes.number,
        nearestBattle: PropTypes.object,
        externalUrl: PropTypes.string,
        signInTokenUrl: PropTypes.string,

        withNews: PropTypes.bool,
        withQuests: PropTypes.bool,

        openPersonalShop: PropTypes.func.isRequired,
        openEventRewards: PropTypes.func.isRequired,
        openBattleSchedule: PropTypes.func.isRequired,
        openLeaderboards: PropTypes.func.isRequired,
        sendEnterGlobalMapSoundState: PropTypes.func.isRequired,
        playEnterGlobalMapSound: PropTypes.func.isRequired,

        isGlobalMapEnabled: PropTypes.bool,
        isCNRealm: PropTypes.bool,
    }

    constructor(props) {
        super(props)

        this.state = {
            time: moment().unix(),
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: moment().unix() }), 10000)
    }
    componentWillUnmount() {
        clearInterval(this.interval)
    }

    handleClick = () => {
        const {
            isSomeServiceEnabled,
            isCraftServiceEnabled,
            personalBonusesEnabled,
            eventRewardsEnabled,
            leaderboardsEnabled,
            battleScheduleEnabled,
            openPersonalShop,
            openEventRewards,
            openBattleSchedule,
            openLeaderboards,
            sendEnterGlobalMapSoundState,
            playEnterGlobalMapSound,
            craftMachineUrl,
            signInTokenUrl,
            externalUrl,
        } = this.props

        switch (true) {
        case !isSomeServiceEnabled:
            return openExternalBrowserWithAuth(signInTokenUrl, externalUrl)
        case leaderboardsEnabled:
            openLeaderboards()
            break
        case isCraftServiceEnabled:
            window.location.href = craftMachineUrl
            return sendEnterGlobalMapSoundState()
        case eventRewardsEnabled:
            openEventRewards()
            break
        case personalBonusesEnabled:
            openPersonalShop()
            break
        case battleScheduleEnabled:
            openBattleSchedule()
            break
        }

        sendEnterGlobalMapSoundState()
        playEnterGlobalMapSound()
    }

    getStartDateMessage(startDate, isPlanned) {
        if (isTodayDay(startDate)) {
            return TODAY_TIME(startDate, isPlanned)
        } else if (isTomorrowDay(startDate)) {
            return TOMMOROW_TIME(startDate, isPlanned)
        }

        return CUSTOM_DATE_TIME(startDate, isPlanned)
    }

    renderBattleSchedule() {
        const nowTimestamp = this.state.time
        const { starts_at:battleDate, is_planned:isPlanned } = this.props.nearestBattle
        const momentBattleDate = moment.unix(battleDate)

        if (!battleDate) return
        if (nowTimestamp > battleDate) {
            return (
                <div className={styles.battleBox}>
                    <div className={styles.battleDate}>
                        <span className={styles.battleText}>{BATTLES_NOW}</span>
                    </div>
                </div>
            )
        }
        return (
            <div className={styles.battleBox}
                data-tip
                data-for='global_map_card_battle_date'
            >
                <div className={styles.battleDate}>
                    {this.getStartDateMessage(momentBattleDate, isPlanned)}
                </div>
                <Tooltip id='global_map_card_battle_date'>
                    <p className={styles['tooltip-message']}>
                        {GLOBAL_MAP_NEAREST_BATTLE_TIME}
                    </p>
                </Tooltip>
            </div>
        )
    }

    render() {
        const {
            isSomeServiceEnabled,
            isGlobalMapEnabled,
            battleScheduleEnabled,
            eventName,
            nearestBattle,
            famePoints,
        } = this.props

        if (!eventName || !isGlobalMapEnabled) {
            const lockedGlobalCardClassNames = this.getGlobalCardClassNames(styles.global_map__locked)

            return (
                <div className={lockedGlobalCardClassNames}>
                    <div className={styles.locked_description}>
                        <h2>{GLOBAL_MAP}</h2>
                        <h3>{GLOBAL_MAP_DISABLED}</h3>
                    </div>
                </div>
            )
        }

        const globalCardClassNames = this.getGlobalCardClassNames()

        const title = isSomeServiceEnabled ? eventName : GLOBAL_MAP

        const subtitle = isSomeServiceEnabled ? GLOBAL_MAP : eventName

        const renderBattleSchedule = battleScheduleEnabled && nearestBattle && !isEmpty(nearestBattle)

        return (
            <div
                className={globalCardClassNames}
                onClick={this.handleClick}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
            >
                {renderBattleSchedule && (
                    <div className={styles.battleHolder}>
                        {this.renderBattleSchedule()}
                    </div>
                )}
                <h2>{title}</h2>
                <h3>{subtitle}</h3>
                <div
                    className={styles.famePoints}
                    data-tip
                    data-for='fame_points'
                >
                    {famePoints !== undefined && (
                        <reactFragment>
                            <FamePoints
                                value={famePoints}
                                iconPosition='before'
                                mixClassName={styles.pfp}
                            />
                            <Tooltip id='fame_points'>
                                <p className={styles['tooltip-subtitle']}>
                                    {PERSONAL_FAME_POINTS}
                                </p>
                                <p className={styles['tooltip-message']}>
                                    {PERSONAL_FAME_POINTS_BALANCE(
                                        <FamePoints
                                            value={famePoints}
                                            iconPosition='before'
                                            mixClassName={styles.pfp}
                                        />
                                    )}
                                </p>
                                <div className={styles['tooltip-divider']} />
                                <p className={styles['tooltip-message']}>
                                    {PERSONAL_FAME_POINTS_EARN}
                                </p>
                            </Tooltip>
                        </reactFragment>
                    )}
                </div>
                {!isSomeServiceEnabled && (
                    <div className={styles.externalUrl} />
                )}
            </div>
        )
    }

    getGlobalCardClassNames(...cardModifiers) {
        const withOnlyNews = this.props.withNews && !this.props.withQuests
        const withOnlyQuests = !this.props.withNews && this.props.withQuests
        const withNewsWithQuests = this.props.withNews && this.props.withQuests
        const commonGlobalCardClassNames = [
            styles.card,
            styles.global_map,
            ...cardModifiers,
            {
                [styles.global_map__with_news]: withOnlyNews,
                [styles.global_map__with_quests]: withOnlyQuests,
                [styles.global_map__with_news_with_quests]: withNewsWithQuests,
            },
        ]

        if (this.props.isCNRealm) {
            return classNames(
                ...commonGlobalCardClassNames,
                {
                    [styles.global_map__cn]: (!this.props.withNews && !this.props.withQuests),
                    [styles.global_map__with_news_cn]: withOnlyNews,
                    [styles.global_map__with_quests_cn]: withOnlyQuests,
                    [styles.global_map__with_news_with_quests_cn]: withNewsWithQuests,
                }
            )
        }

        return classNames(commonGlobalCardClassNames)
    }
}

const stateToProps = ({ craftMachine, globalMap, settings, clan }) => {
    const hasClan = (clan.id !== null)
    const personalShopEnabled = (globalMap.personal_bonuses_enabled || globalMap.event_rewards_enabled)
    const battleScheduleEnabled = (globalMap.battle_schedule_enabled && hasClan)
    const leaderboardsEnabled = (globalMap.leaderboards_enabled && hasClan)
    const isCraftServiceEnabled = craftMachine.is_craft_service_enabled

    const isSomeServiceEnabled = (
        leaderboardsEnabled ||
        personalShopEnabled ||
        battleScheduleEnabled ||
        isCraftServiceEnabled
    )

    return {
        craftMachineUrl: settings.craftMachineUrl,
        personalShopEnabled,
        personalBonusesEnabled: globalMap.personal_bonuses_enabled,
        eventRewardsEnabled: globalMap.event_rewards_enabled,
        battleScheduleEnabled,
        leaderboardsEnabled,
        isCraftServiceEnabled,
        isSomeServiceEnabled,
        eventName: globalMap.context_id, // season or event name
        famePoints: globalMap.fame_points,
        nearestBattle: globalMap.nearest_battle,
        externalUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        isGlobalMapEnabled: !!settings.globalMapUrl,
        isCNRealm: settings.isCNRealm,
    }
}

const dispatchToProps = {
    openPersonalShop: () => push(WGCWX_SHOP),
    openEventRewards: () => push(WGCWX_SHOP_REWARDS),
    openBattleSchedule: () => push(WGCWX_BATTLE_SCHEDULE),
    openLeaderboards: () => push(WGCWX_LEADERBOARDS),
    sendEnterGlobalMapSoundState,
    playEnterGlobalMapSound,
}

export default connect(stateToProps, dispatchToProps)(GlobalMapCard)



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/GlobalMapCard.jsx